// Read-only project + unit lookup for PROJECT-deal sale drafts.
import client from './client';

export const listProjects = (params = {}) => client.get(`/api/agent/projects`, { params });
export const getProjectById = (id, params = {}) => client.get(`/api/agent/projects/${id}`, { params });
export const listProjectUnits = (id, params = {}) => client.get(`/api/agent/projects/${id}/units`, { params });

// Project materials (brochures, price lists, floor plans, photos, videos…) HQ
// uploads in the portal. `with_materials=1` narrows the list to active projects
// that have something to show and adds `materials_count` + `cover_url`; the sale
// form keeps calling listProjects() without it.
export const listMaterialProjects = (params = {}) => client.get(`/api/agent/projects`, { params: { ...params, with_materials: 1 } });
export const listProjectMaterials = (id) => client.get(`/api/agent/projects/${id}/materials`);
